/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthHl7
 */
export interface TenantHealthHl7 {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHl7
     */
    processed_1d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHl7
     */
    failed_1d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHl7
     */
    processed_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHl7
     */
    failed_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHl7
     */
    processed_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthHl7
     */
    failed_30d?: number;
}

/**
 * Check if a given object implements the TenantHealthHl7 interface.
 */
export function instanceOfTenantHealthHl7(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthHl7FromJSON(json: any): TenantHealthHl7 {
    return TenantHealthHl7FromJSONTyped(json, false);
}

export function TenantHealthHl7FromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthHl7 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'processed_1d': !exists(json, 'processed_1d') ? undefined : json['processed_1d'],
        'failed_1d': !exists(json, 'failed_1d') ? undefined : json['failed_1d'],
        'processed_7d': !exists(json, 'processed_7d') ? undefined : json['processed_7d'],
        'failed_7d': !exists(json, 'failed_7d') ? undefined : json['failed_7d'],
        'processed_30d': !exists(json, 'processed_30d') ? undefined : json['processed_30d'],
        'failed_30d': !exists(json, 'failed_30d') ? undefined : json['failed_30d'],
    };
}

export function TenantHealthHl7ToJSON(value?: TenantHealthHl7 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'processed_1d': value.processed_1d,
        'failed_1d': value.failed_1d,
        'processed_7d': value.processed_7d,
        'failed_7d': value.failed_7d,
        'processed_30d': value.processed_30d,
        'failed_30d': value.failed_30d,
    };
}

